export default {
    buscando: false,
    items: [],
    selecionado: {},
    perfis: []
}